import {Component, DOCUMENT, Inject, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {ToastModule} from 'primeng/toast';

@Component({
  selector: 'app-offline-layout',
  templateUrl: './offline-layout.html',
  imports: [
    RouterOutlet,
    ToastModule,
  ]
})

export class OfflineLayout implements OnInit, OnDestroy{

  public debug: boolean = false;
  public projectName: string;

  constructor(
    @Inject(DOCUMENT) document: any,
    public router: Router,
    public renderer2: Renderer2
  ) {

    this.debug = environment.debug;
    this.projectName = environment.projectName;

  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }


}
